import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import TitleText from '../../components/formlib/TitleText';
import ClientInfoFaceSheet from './ClientInfoFaceSheet';
import CommunicationFaceSheet from './CommunicationFaceSheet';
import ClientFilesFaceSheet from './ClientFilesFaceSheet';
import InsuranceFaceSheet from './InsuranceFaceSheet';
import UpcomingEventsFaceSheet from './UpcomingEventsFaceSheet';
import CustomBackArrow from '../../components/imagepickers/backArrow';
import { useNavigate } from 'react-router';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import {
  ReferralResponseType,
  addReReferral,
  deleteSession,
  getAllReferrals,
  getFacesheetDetails,
  getListByRole,
  syncOfflineData,
  updateFacesheetDetails,
} from '../../services/configApi/Clients';
import {
  AddReReferralFaceSheet,
  DateString,
  FaceSheetType,
  IntakeCoordinatorsType,
  OptionType,
  ReferralContactJsonType,
  ResourceRepoDTO,
  ServiceCoordinatorsType,
} from '../../utils/type';
import {
  AlertColor,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  autocompleteClasses,
} from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';
import { ReactComponent as Close } from '../../assets/images/x.svg';
import { ReactComponent as Document } from '../../assets/images/documentUpload.svg';
import moment from 'moment';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import AutocompleteSearch from '../../components/formlib/AutocompleteSearch';
import DatePickerComponent from '../../components/formlib/DatePickerComponent';
import dayjs, { Dayjs } from 'dayjs';
import { useIntl } from 'react-intl';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import { Formik, FormikErrors, FormikProps } from 'formik';
import * as yup from 'yup';
import {
  calculateMonths,
  datePickerMinDateMaxDateValidate,
} from '../../utils/dateUtil';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import { CLIENTS_DASHBOARD_ROUTE_NAME } from '../../routes/Routing';
import ClientJourneyWrapper from './ClientJourneyWrapper';
import { createclientsyncobj, deleteData } from '../../services/Offline';
import TransitionFaceSheet from './TransitionFaceSheet';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import {
  EMAIL_REGEX,
  EST_DATETIME_REGEX,
  LOCAL_DATE_TIME_FORMAT,
  LOCAL_DATE_TIME_UTC_FORMAT,
  PREVIEW_DOCUMENT_EXTENSIONS,
  REFERRAL_ID_KEY,
  REFERRAL_PROGRAM_KEY,
  REFERRAL_STATUS_KEY,
} from '../../services/Constant';
import { getResponseDB } from '../../services/storageDB';
import { LookUpContext } from '../../context/LookUpContextProvider';

import { ReactComponent as DownloadIcon } from '../../assets/images/offlineDownload.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/offlineDelete.svg';
import { ReactComponent as SyncIcon } from '../../assets/images/offlineSync.svg';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import CustomRadioButton, {
  RadioButtonData,
} from '../../components/formlib/CustomRadioButton';
import _, { debounce } from 'lodash';
import { formatName } from '../../utils/nameUtils';
import {
  DiagnosisCode,
  getCodesAndDescriptionNew,
} from '../../services/configApi/codelist/diagnosticCodes';
import ProgressNotesFaceSheet from './ProgressNotesFaceSheet';
import { referralTypeOptions } from '../referral/AddNewReferralDetails';
import PovertyJsonData from '../intake/IntakeJSON/FamilyHistory/Poverty.json';
import Textinput from '../../components/formlib/Textinput';
import {
  formatPhoneNumber,
  nameValidation,
} from '../../utils/formValidationUtil';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import { ReactComponent as DeleteIconBtn } from '../../assets/images/deleteAlertIcon.svg';
import TextWithIcon from '../../components/formlib/TextWithIcon';
import ModalPopup from '../../components/formlib/ModalPopup';
import { extractFileExtension } from '../../utils/fileUtils';
import FilePreviewDialog from '../../components/formlib/modal/FilePreviewDialog';
import {
  DownloadClientFilesResponse,
  getClientFilesUrl,
} from '../../services/configApi/clientFiles/clientFilesProvider';
import SmallTypography from '../../components/formlib/SmallTypography';
import { convertGenderToFrontend } from '../../utils/genderUtil';
import { useMultiplePermissions } from '../../hooks/usePermissions';

const cardStyle = { background: 'white', borderRadius: '6px', padding: '16px' };

export interface DiagnosisOptionType {
  id: string;
  label: string;
  isDeleted: boolean;
}

export interface FaceSheetFormType {
  intakeCoordinator: string | null;
  serviceCoordinator: string | null;
  referralDiagnosisCode: string | null;
  assessmentHoursDec: number | null;
  noOfAssessmentHoursUsedDec: number | null;
  remainingAssessmentHoursDec: number | null;
  isSecondaryProgramServices: boolean;
  eicsConsentToAccessInsurance: number;
  elContactNumber: string | null;
  elProgram: string | null;
  consentToAccessStartDate: string | null;
  referralBeginDate: DateString;
  serviceCoordinatorStartDate: DateString;
  ifspDueDate: string | null;
  referralType: string | null;
  eligibilityDate: DateString;
  povertyLevel: string | null;
  referralContact: ReferralContactJsonType[] | [];
}

const nullInitialValues: FaceSheetFormType = {
  intakeCoordinator: '',
  serviceCoordinator: null,
  referralDiagnosisCode: '',
  assessmentHoursDec: null,
  noOfAssessmentHoursUsedDec: null,
  remainingAssessmentHoursDec: null,
  isSecondaryProgramServices: false,
  eicsConsentToAccessInsurance: 0,
  elContactNumber: '',
  elProgram: '',
  consentToAccessStartDate: dayjs().format('MM/DD/YYYY'),
  referralBeginDate: null,
  serviceCoordinatorStartDate: null,
  ifspDueDate: '',
  referralType: 'New',
  eligibilityDate: null,
  povertyLevel: '',
  referralContact: [
    {
      referralContactDate: null,
      referralContactPhone: '',
      referralContactFax: '',
      referralContactEmail: '',
      referralContactType: 'Referral Contact',
      referralContactJobTitle: '',
      referralContactName: '',
      referralSource: '',
      referralReason: '',
      isDcf: false,
      notes: '',
    },
  ],
};

const referralContactSchema = yup.object().shape({
  referralContactName: yup.string().nullable(),
  referralContactJobTitle: yup.string().nullable(),
  referralisDcf: yup.boolean().nullable(),
  referralContactDate: yup
    .date()
    .required('AddNewReferralDetails.referralContactDate.Validation')
    .nullable(),
  referralSource: yup.string().required('referralSource.Validation').nullable(),
  referralReason: yup.string().required('referralReason.Validation').nullable(),
  referralContactPhone: yup.string().nullable(),
  referralContactEmail: yup
    .string()
    .matches(EMAIL_REGEX, 'EmailFormat.Validation')
    .nullable(),
  referralContactFax: yup.string().min(12, 'FaxFormat.Validation').nullable(),
  referralContactType: yup.string().nullable(),
  notes: yup.string().nullable(),
});

const validationSchema = yup.object().shape({
  intakeCoordinator: yup.string().nullable(),
  serviceCoordinator: yup.string().nullable(),
  assessmentHoursDec: yup.number().nullable(),
  noOfAssessmentHoursUsedDec: yup.number().nullable(),
  remainingAssessmentHoursDec: yup.number().nullable(),
  isSecondaryProgramServices: yup.boolean().default(false),
  eicsConsentToAccessInsurance: yup.number().default(0),
  consentToAccessStartDate: yup
    .string()
    .required('insuranceConsentDateRequired')
    .nullable(),
  referralBeginDate: yup
    .date()
    .required('AddNewReferralDetails.referralBeginDate.Validation')
    .nullable(),
  serviceCoordinatorStartDate: yup
    .date()
    .nullable()
    .when('serviceCoordinator', {
      is: (value: string | null | undefined) =>
        value !== null && value !== undefined && value !== '',
      then: (schema) => schema.required('serviceCoordinatorStartDateRequired'),
    }),
  ifspDueDate: yup.string().nullable(),
  referralType: yup.string().nullable(),
  eligibilityDate: yup.date().nullable(),
  povertyLevel: yup.string().nullable(),
  referralContact: yup.array().of(referralContactSchema),
});

export const eicsConcentValues: RadioButtonData[] = [
  { defaultLabel: 'Granted', labelId: 'grantedText', value: '1' },
  { defaultLabel: 'Denied', labelId: 'deniedText', value: '2' },
  { defaultLabel: 'Unknown', labelId: 'RiskFactor.Unknown', value: '0' },
];

const referralCreationSchema = yup.object().shape({
  referralBeginDate: yup
    .date()
    .required('AddNewReferralDetails.referralBeginDate.Validation')
    .nullable(),
  referralContact: referralContactSchema,
});

const referralInitialValues: AddReReferralFaceSheet = {
  referralBeginDate: null,
  referralContact: {
    referralContactDate: null,
    referralContactName: '',
    referralContactType: 'otherText',
    referralContactJobTitle: '',
    referralContactEmail: '',
    referralContactFax: '',
    referralContactPhone: '',
    referralSource: '',
    referralReason: '',
    isDcf: false,
    notes: '',
  },
  ifspDueDate: null,
};

const FaceSheetScreen = () => {
  const navigation = useNavigate();
  const rctl = useIntl();
  const clientId = localStorage.getItem('ClientId');
  const referralId = localStorage.getItem(REFERRAL_ID_KEY);
  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;
  const [faceSheetDetails, setFaceSheetDetails] = useState<FaceSheetType>();
  const [serviceDialogFlag, setServiceDialogFlag] = useState(false);
  const [intakeDialogFlag, setIntakeDialogFlag] = useState(false);
  const [formDialogFlag, setFormDialogFlag] = useState(false);
  const [referralFormDialogFlag, setReferralFormDialogFlag] = useState(false);
  const [faceSheetForm, setFaceSheetForm] =
    useState<FaceSheetFormType>(nullInitialValues);
  const faceSheetFormBkp = useRef<FaceSheetFormType>({ ...nullInitialValues });
  const formikRef = useRef<FormikProps<FaceSheetFormType>>(null);
  const faceshettFormValue = useRef<FaceSheetFormType>();

  const [open, setOpen] = React.useState(false);
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = React.useState('');

  const [selectedDphId, setSelectedDphId] = React.useState(referralId);

  const [serviceCoordinatorsList, setServiceCoordinatorsList] = useState<
    OptionType[]
  >([]);
  const [intakeCoordinatorsList, setIntakeCoordinatorsList] = useState<
    OptionType[]
  >([]);

  const [selectedServiceCoordinator, setSelectedServiceCoordinator] = useState<
    OptionType | null | undefined
  >();

  const [selectedIntakeCoordinator, setSelectedIntakeCoordinator] = useState<
    OptionType | null | undefined
  >();
  const [minServiceCoordinatorDate, setMinServiceCoordinatorDate] =
    useState<Dayjs | null>(null);
  const [referralBeginDate, setReferralBeginDate] = useState<Dayjs | null>(
    null,
  );
  const [previousSCStartDate, setPreviousSCStartDate] = useState<Dayjs | null>(
    null,
  );
  const [scStartDateError, setScStartDateError] = useState<string>('');
  const [resourceData, setResourceData] = useState<ResourceRepoDTO>();
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<ResourceRepoDTO>();
  setTimeout(() => window.dispatchEvent(new Event('resize')), 100);

  const [dphIdValues, setDphIdValues] = useState<OptionType[]>([]);
  const [makedownload, setMakedownload] = useState(false);
  const [deleteMakedownload, setDeleteMakedownload] = useState(false);
  const [serviceCoordinatorValidation, setServiceCoordinatorValidation] =
    useState(false);
  const [sync, setSync] = useState(false);
  const { lookups, lookupsDemographics, updateDemographics } =
    useContext(LookUpContext);

  const [selectedDiagnosisCodesList, setSelectedDiagnosisCodesList] =
    useState<OptionType | null>(null);
  const [diagnosisCodesList, setDiagnosisCodesList] = useState<
    DiagnosisOptionType[]
  >([]);

  const [referralReasons, setReferralReasons] = useState<OptionType[]>([]);
  const [referralSources, setReferralSources] = useState<OptionType[]>([]);

  const [cancelModal, setCancelModal] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState<boolean>(false);

  const formRef = React.useRef<FormikProps<AddReReferralFaceSheet>>(null);
  const [dcfChecked, setDcfChecked] = useState<boolean>(false);

  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const hasEditPermission =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
        permissions['backend.in_active_referrals'].canEdit;

  const clientReferralDetails =
    localStorage.getItem('clientReferralDetails') ?? '[]';

  const secondaryProgramReferral = JSON.parse(
    clientReferralDetails,
  ) as ReferralResponseType[];

  const secondaryProgramReferralId = secondaryProgramReferral.filter(
    (referral) => referral.isSecondaryProgramServices,
  )?.[0]?.referralId;

  useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  const validateForm = (value: FaceSheetFormType) => {
    const errors: Partial<FaceSheetFormType> = {};

    value.referralContact.forEach((contact, index) => {
      if (contact.referralContactDate) {
        // Check if referralContactDate is before date of birth or after today's date
        if (
          dayjs(contact.referralContactDate).isBefore(
            faceSheetDetails?.demographics.dateOfBirth,
          )
        ) {
          errors.referralContact = errors.referralContact || [];
          errors.referralContact[index] = errors.referralContact[index] || {
            referralContactDate: '',
            referralContactPhone: '',
            referralContactFax: '',
            referralContactEmail: '',
            referralContactType: '',
            referralContactJobTitle: '',
            referralContactName: '',
            referralSource: '',
            referralReason: '',
            isDcf: false,
            notes: '',
          };
          errors.referralContact[index].referralContactDate =
            'Facesheet.Error.ReferralContactBeforeDobDate';
        }

        if (
          dayjs(contact.referralContactDate).isAfter(
            dayjs().format('MM/DD/YYYY'),
          )
        ) {
          errors.referralContact = errors.referralContact || [];
          errors.referralContact[index] = errors.referralContact[index] || {
            referralContactDate: '',
            referralContactPhone: '',
            referralContactFax: '',
            referralContactEmail: '',
            referralContactType: '',
            referralContactJobTitle: '',
            referralContactName: '',
            referralSource: '',
            referralReason: '',
            isDcf: false,
            notes: '',
          };
          errors.referralContact[index].referralContactDate =
            'Facesheet.Error.ReferralContactFutureDate';
        }

        if (datePickerMinDateMaxDateValidate(contact.referralContactDate)) {
          errors.referralContact = errors.referralContact || [];
          errors.referralContact[index] = errors.referralContact[index] || {
            referralContactDate: '',
            referralContactPhone: '',
            referralContactFax: '',
            referralContactEmail: '',
            referralContactType: '',
            referralContactJobTitle: '',
            referralContactName: '',
            referralSource: '',
            referralReason: '',
            isDcf: false,
            notes: '',
          };

          errors.referralContact[index].referralContactDate =
            'datePickerMinDateMaxDateValidate';
        }
      }
    });

    if (value.referralBeginDate) {
      if (datePickerMinDateMaxDateValidate(value.referralBeginDate)) {
        errors.referralBeginDate = 'datePickerMinDateMaxDateValidate';
      }
      if (
        dayjs(value.referralBeginDate).isAfter(dayjs().format('MM/DD/YYYY'))
      ) {
        errors.referralBeginDate = 'Facesheet.Error.ReferralBeginFutureDate';
      }
    }

    return errors;
  };

  const validateReferralCreationForm = (value: AddReReferralFaceSheet) => {
    const errors: Partial<AddReReferralFaceSheet> = {};

    if (value.referralBeginDate) {
      if (datePickerMinDateMaxDateValidate(value.referralBeginDate)) {
        errors.referralBeginDate = 'datePickerMinDateMaxDateValidate';
      }
      if (
        dayjs(value.referralBeginDate).isAfter(dayjs().format('MM/DD/YYYY'))
      ) {
        errors.referralBeginDate = 'Facesheet.Error.ReferralBeginFutureDate';
      }
    }

    if (value.referralContact.referralContactDate) {
      if (
        dayjs(value.referralContact.referralContactDate).isBefore(
          faceSheetDetails?.demographics.dateOfBirth,
        )
      ) {
        errors.referralContact = errors.referralContact || {
          referralContactDate: '',
          referralContactPhone: '',
          referralContactFax: '',
          referralContactEmail: '',
          referralContactType: '',
          referralContactJobTitle: '',
          referralContactName: '',
          referralSource: '',
          referralReason: '',
          isDcf: false,
          notes: '',
        };
        errors.referralContact.referralContactDate =
          'Facesheet.Error.ReferralContactBeforeDobDate';
      }

      if (
        dayjs(value.referralContact.referralContactDate).isAfter(
          dayjs().format('MM/DD/YYYY'),
        )
      ) {
        errors.referralContact = errors.referralContact || {
          referralContactDate: '',
          referralContactPhone: '',
          referralContactFax: '',
          referralContactEmail: '',
          referralContactType: '',
          referralContactJobTitle: '',
          referralContactName: '',
          referralSource: '',
          referralReason: '',
          isDcf: false,
          notes: '',
        };
        errors.referralContact.referralContactDate =
          'Facesheet.Error.ReferralContactFutureDate';
      }

      if (
        datePickerMinDateMaxDateValidate(
          value.referralContact.referralContactDate,
        )
      ) {
        errors.referralContact = errors.referralContact || {
          referralContactDate: '',
          referralContactPhone: '',
          referralContactFax: '',
          referralContactEmail: '',
          referralContactType: '',
          referralContactJobTitle: '',
          referralContactName: '',
          referralSource: '',
          referralReason: '',
          isDcf: false,
          notes: '',
        };
        errors.referralContact.referralContactDate =
          'datePickerMinDateMaxDateValidate';
      }
    }

    return errors;
  };

  useEffect(() => {
    if (lookups === null) {
      return;
    }
    setReferralReasons(() => {
      return lookups.referralReason.map((reason) => {
        return {
          label: reason.description,
          id: reason.code,
        };
      });
    });
    setReferralSources(() => {
      return lookups.referralSource.map((source) => {
        return {
          label: source.description,
          id: source.code,
        };
      });
    });
  }, [lookups]);

  useEffect(() => {
    const getDiagnosisCodes = async () => {
      await handleDiagnosisDataGetAPI();
    };
    getDiagnosisCodes();
  }, []);

  const handleDiagnosisDataGetAPI = async () => {
    toggleLoader(true);
    getCodesAndDescriptionNew()
      .then(async (response: DiagnosisCode[]) => {
        const diagnosisCodeList: DiagnosisOptionType[] = [];
        if (response.length > 0) {
          response.forEach((codeDetails) => {
            if (!codeDetails.isDeleted && codeDetails.qualifyingDiagnosis) {
              diagnosisCodeList.push({
                id: codeDetails.code,
                label: codeDetails.oneYearEligibility
                  ? `${codeDetails.code} - * ${codeDetails.description}`
                  : `${codeDetails.code} - ${codeDetails.description}`,
                isDeleted: codeDetails.isDeleted
                  ? codeDetails.isDeleted
                  : false,
              });
            }
          });

          await fetchFaceSheetDetails(diagnosisCodeList);
        }
      })
      .catch((error) => {
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId(error);
          setToastrDefaultMessage(error);
        }
      });
  };

  useEffect(() => {
    if (formikRef.current?.values?.referralDiagnosisCode) {
      const data = diagnosisCodesList.filter((obj) => {
        const medicalDiagnosis =
          formikRef.current?.values?.referralDiagnosisCode ?? '';
        return obj.label.includes(medicalDiagnosis);
      });
      if (formikRef.current)
        formikRef.current.setFieldValue(
          'referralDiagnosisCode',
          data[0]?.label,
        );
    }
  }, [diagnosisCodesList]);

  const handlePreviewClick = (fileItem: ResourceRepoDTO | undefined) => {
    // call getClientFilesUrl api
    toggleLoader(true);
    if (fileItem === undefined || fileItem === null) {
      return;
    }
    const filteredName = fileItem.resourceUrl.split('client-repo/')[1];
    getClientFilesUrl(filteredName)
      .then((response: DownloadClientFilesResponse) => {
        toggleLoader(false);
        setShowPreview(true);
        setSelectedFile({
          ...fileItem,
          resourceUrl: response.url,
        });
      })
      .catch((error) => {
        toggleLoader(false);
        //display toaster
        setToastrDefaultMessage('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('povertyLevelError');
          setToastrDefaultMessage('Failed to preview poverty level.');
        }
      });
  };

  useEffect(() => {
    if (makedownload) {
      toggleLoader(true);
      const handleFaceSheetList = async () => {
        await fetchFaceSheetDetails(diagnosisCodesList);
      };
      handleFaceSheetList();
    }
  }, [makedownload]);

  useEffect(() => {
    toggleLoader(true);

    const getAllReferralsBasedOnSelectedClient = async () => {
      if (localStorage.getItem('defaultReferralId') === null) {
        const getReferralId = localStorage.getItem('referralId');
        if (getReferralId)
          localStorage.setItem('defaultReferralId', getReferralId);
      }

      const defaultReferralId = localStorage.getItem('defaultReferralId');
      if (defaultReferralId) {
        await fetchRefferralDetails(defaultReferralId);
      }
    };
    getAllReferralsBasedOnSelectedClient();
    makeDownloadAndSync();
  }, []);

  const fetchRefferralDetails = async (defaultReferralId: string) => {
    toggleLoader(true);
    if (clientId) {
      await getAllReferrals(clientId, defaultReferralId)
        .then(async (response: ReferralResponseType[]) => {
          if (response) {
            localStorage.setItem(
              'clientReferralDetails',
              JSON.stringify(response),
            );

            const referralDetails = JSON.stringify(response);

            if (referralDetails) {
              const parsedReferralDetails = JSON.parse(referralDetails);
              setDphIdValues(() => {
                return parsedReferralDetails.map((d: ReferralResponseType) => {
                  return {
                    label:
                      d.dphId === null || d.dphId === ''
                        ? 'Yet to receive'
                        : d.dphId,
                    id: d.referralId,
                    color: d.isSecondaryProgramServices ? '#F96300' : 'default',
                  };
                });
              });
            }
          }
        })
        .catch((error) => {
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('clientLoadError');
            setToastrDefaultMessage('Failed to get client details');
          }
        });
    }
  };

  const makeDownloadAndSync = async () => {
    setMakedownload(false);
    setSync(false);
    setDeleteMakedownload(false);
  };

  const handleRolesList = (faceSheetResponseDetails: FaceSheetType) => {
    const handleServiceCoordinatorsList = async () => {
      const serviceCoordinatorsDetails = await getListByRole(
        'backend.role.service_coordinator',
        [faceSheetResponseDetails.demographics.serviceCoordinator ?? ''],
      );
      const serviceCoList: OptionType[] = [];
      serviceCoordinatorsDetails.forEach((coordinator) => {
        serviceCoList.push({
          id: coordinator.id,
          label: formatName(
            coordinator.firstName,
            null,
            coordinator.lastName,
            null,
          ),
        });
      });
      setServiceCoordinatorsList(serviceCoList);

      const selected: OptionType | undefined = serviceCoList.find(
        (s) =>
          s.id === faceSheetResponseDetails.demographics.serviceCoordinator,
      );
      if (selected) {
        setSelectedServiceCoordinator(selected);
      } else {
        setSelectedServiceCoordinator(null);
      }
    };
    handleServiceCoordinatorsList();

    const handleIntakeCoordinatorsList = async () => {
      const intakeCoordinatorsDetails = await getListByRole(
        'backend.role.intake_coordinator',
        [faceSheetResponseDetails.demographics.intakeCoordinator ?? ''],
      );
      const intakeCoList: OptionType[] = [];
      intakeCoordinatorsDetails.forEach((coordinator) => {
        intakeCoList.push({
          id: coordinator.id,
          label: formatName(
            coordinator.firstName,
            null,
            coordinator.lastName,
            null,
          ),
        });
      });
      setIntakeCoordinatorsList(intakeCoList);

      const selected: OptionType | undefined = intakeCoList.find(
        (s) => s.id === faceSheetResponseDetails.demographics.intakeCoordinator,
      );
      if (selected) {
        setSelectedIntakeCoordinator(selected);
      } else {
        setSelectedIntakeCoordinator(null);
      }
    };
    handleIntakeCoordinatorsList();
  };

  const handleServiceDailog = () => {
    if (
      faceSheetDetails &&
      faceSheetDetails.demographics.serviceCoordinatorHistory.length > 0
    )
      setServiceDialogFlag(true);
  };

  const handleIntakeDailog = () => {
    if (
      faceSheetDetails &&
      faceSheetDetails.demographics.intakeCoordinatorHistory.length > 0
    )
      setIntakeDialogFlag(true);
  };

  const handleFormDailog = async () => {
    await fetchFaceSheetDetails(diagnosisCodesList);
    setFormDialogFlag(true);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleFormSubmit = (formSubmitValues: FaceSheetFormType) => {
    if (
      formSubmitValues.povertyLevel !== null &&
      (formSubmitValues.serviceCoordinator === null ||
        formSubmitValues.serviceCoordinator === '')
    ) {
      faceshettFormValue.current = formSubmitValues;
      setServiceCoordinatorValidation(true);
    } else {
      formSubmit(formSubmitValues);
    }
  };

  const formSubmit = (formSubmitValues: FaceSheetFormType) => {
    setServiceCoordinatorValidation(false);
    const updatedValues: FaceSheetFormType = {
      ...formSubmitValues,
      consentToAccessStartDate:
        formSubmitValues.consentToAccessStartDate ??
        dayjs().format('MM/DD/YYYY'),
    };

    if (
      faceSheetDetails &&
      faceSheetDetails.demographics.serviceCoordinatorHistory.length > 0
    ) {
      const serviceCoordinator =
        faceSheetDetails.demographics.serviceCoordinatorHistory.at(-1);
      if (
        serviceCoordinator?.id === updatedValues.serviceCoordinator &&
        dayjs(serviceCoordinator.startTime).isSame(
          updatedValues.serviceCoordinatorStartDate,
        )
      ) {
        updatedValues.serviceCoordinator = null;
        updatedValues.serviceCoordinatorStartDate = null;
      }
    }

    const params = {
      intakeCoordinator: updatedValues.intakeCoordinator,
      serviceCoordinator: updatedValues.serviceCoordinator,
      serviceCoordinatorStartDate: updatedValues.serviceCoordinatorStartDate,
      isSecondaryProgramServices: updatedValues.isSecondaryProgramServices,
      eicsConsentToAccessInsurance: updatedValues.eicsConsentToAccessInsurance,
      consentToAccessStartDate: updatedValues.consentToAccessStartDate,
      referral: {
        referralBeginDate: updatedValues.referralBeginDate,
        ifspDueDate: updatedValues.ifspDueDate,
        referralType: updatedValues.referralType,
        eligibilityDate: updatedValues.eligibilityDate,
        povertyLevel: updatedValues.povertyLevel,
        referralDiagnosisCode: updatedValues.referralDiagnosisCode,
        assessmentHoursDec: updatedValues.assessmentHoursDec,
        noOfAssessmentHoursUsedDec: updatedValues.noOfAssessmentHoursUsedDec,
        remainingAssessmentHoursDec: updatedValues.remainingAssessmentHoursDec,
        referralContact: updatedValues.referralContact,
      },
    };

    if (params) {
      if (clientId) {
        toggleLoader(true);
        updateFacesheetDetails(params, clientId)
          .then(async (response) => {
            if (response) {
              await fetchFaceSheetDetails(diagnosisCodesList);
              setOpen(true);
              setToastrVariable('success');
              setToastrId('updateSuccessMessage');
              setToastrDefaultMessage('Updated Successfully');
              setFormDialogFlag(false);
            }
            toggleLoader(false);
          })
          .catch((error) => {
            toggleLoader(false);
            setOpen(true);
            setToastrVariable('error');
            const apiError = error as ApiError;
            if (isCustomError(error)) {
              setToastrId(apiError.id);
              setToastrDefaultMessage(apiError.message);
            } else if (error.code === 1056 || error.code === 1058) {
              setToastrId('Facesheet.apiErrorMsg');
              setToastrDefaultMessage(apiError.message);
            } else if (error.code === 1149) {
              setToastrId('serviceCoordinatorStartDateOverlapError');
              setToastrDefaultMessage(apiError.message);
            } else if (error.code === 1120) {
              setToastrId('Facesheet.apiExceptionErrorMsg');
              setToastrDefaultMessage(apiError.message);
            } else if (error.code === 1164) {
              setToastrId('beginDateCannotChangeErrorMessage');
              setToastrDefaultMessage(apiError.message);
            } else if (error.code === 1173) {
              setToastrId('beginDateCannotBeAfterInitialEvalDateErrorMessage');
              setToastrDefaultMessage(apiError.message);
            } else {
              setToastrId('updateFailureMessage');
              setToastrDefaultMessage('Failed to update details');
            }
          });
      }
    }
  };

  const syncData = async () => {
    const referralid: string = localStorage.getItem('referralId') ?? '';
    const result = await createclientsyncobj(referralid);
    toggleLoader(true);
    syncOfflineData(result)
      .then(async (response) => {
        if (response) {
          const selectedProgram: string | null =
            localStorage.getItem('selectedProgram');
          let programId: string = '';
          if (selectedProgram !== null) {
            programId = JSON.parse(selectedProgram).id;
          }

          await deleteData(programId, referralid).then(async () => {
            const referralIds = (await getResponseDB(
              'referralIds',
            )) as string[];
            if (referralIds) {
              if (referralIds.length === 0) {
                nullifyToken();
              }
            } else {
              nullifyToken();
            }
            makeDownloadAndSync();
          });

          setOpen(true);
          setToastrVariable('success');
          setToastrId('synced');
          setToastrDefaultMessage('Data synced successfully');
        }
      })
      .catch(() => {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('syncfail');
        setToastrDefaultMessage('Failed to sync data');
      })
      .finally(() => {
        makeDownloadAndSync();
        toggleLoader(false);
      });
  };

  const deleteOfflineData = async () => {
    toggleLoader(true);

    const selectedProgram: string | null =
      localStorage.getItem('selectedProgram');
    let programId: string = '';
    if (selectedProgram !== null) {
      programId = JSON.parse(selectedProgram).id;
    }
    const referralid: string = localStorage.getItem('referralId') ?? '';
    const referralRemaining = (await getResponseDB('referralIds')) as string[];
    let sessionIntimation: boolean = false;
    if (referralRemaining && referralRemaining.length === 1) {
      sessionIntimation = true;
    }

    if (sessionIntimation) {
      await deleteSession()
        .then(async (response) => {
          if (response) {
            deleteReferralData(programId, referralid);
          } else {
            setOpen(true);
            setToastrVariable('error');
            setToastrId('deleteSession');
            setToastrDefaultMessage(
              "Couldn't deleted offline data, please try again later.",
            );
            toggleLoader(false);
          }
        })
        .catch(() => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId('deleteSession');
          setToastrDefaultMessage(
            "Couldn't deleted offline data, please try again later.",
          );
          toggleLoader(false);
        });
    } else {
      deleteReferralData(programId, referralid);
    }
  };

  const deleteReferralData = async (programId: string, referralid: string) => {
    await deleteData(programId, referralid).then(async () => {
      const referralIds = (await getResponseDB('referralIds')) as string[];
      if (referralIds) {
        if (referralIds.length === 0) {
          nullifyToken();
        }
      } else {
        nullifyToken();
      }
      makeDownloadAndSync();
      setOpen(true);
      setToastrVariable('success');
      setToastrId('deleteMakedownload');
      setToastrDefaultMessage('Deleted offline data');
      toggleLoader(false);
    });
  };

  const nullifyToken = () => {
    localStorage.setItem('accessToken', 'EXPIRE SESSION');
    localStorage.setItem('refreshToken', 'EXPIRE SESSION');
    localStorage.setItem('offlineToken', 'EXPIRE SESSION');
  };

  const fetchFaceSheetDetails = async (
    filteredDiagnosisCodeList: DiagnosisOptionType[],
  ) => {
    if (clientId) {
      toggleLoader(true);
      await getFacesheetDetails(clientId)
        .then((response) => {
          if (response) {
            // update the re-evaluation data
            const data = response;
            if (data.demographics.resourceDto) {
              setResourceData(data.demographics.resourceDto);
            }
            const journeyCounts: { [key: string]: number } = {};

            data.clientJourney.forEach((item) => {
              // Count the occurrences of each journey name
              journeyCounts[item.journeyName] =
                (journeyCounts[item.journeyName] || 0) + 1;

              // If it's the 2nd or subsequent occurrence of "backend.journey_name.evaluation", update to "backend.journey_name.re-evaluation"
              if (
                item.journeyName === 'backend.journey_name.evaluation' &&
                journeyCounts[item.journeyName] > 1
              ) {
                item.journeyName = 'backend.journey_name.re-evaluation';
              }
            });

            data.demographics.consentToAccessStartDate =
              response.demographics.consentToAccessStartDate === null &&
              response.demographics.eicsConsentToAccessInsurance === 0
                ? response.demographics.referralDate
                : response.demographics.consentToAccessStartDate;
            data.clientFiles.forEach((file) => {
              if (
                file.tags.timestamp &&
                EST_DATETIME_REGEX.test(file.tags.timestamp)
              ) {
                file.tags.timestamp = dayjs(
                  file.tags.timestamp,
                  'MM-DD-YYYY HH:MM.SS',
                ).format(LOCAL_DATE_TIME_FORMAT);
              } else {
                file.tags.timestamp = moment(
                  file.tags.timestamp,
                  LOCAL_DATE_TIME_UTC_FORMAT,
                )
                  .utc()
                  .local()
                  .format(LOCAL_DATE_TIME_FORMAT);
              }
            });
            setFaceSheetDetails(data);
            updateDemographics(data.demographics);

            // Set minimum date for service coordinator based on history and referral begin date
            let calculatedMinDate: Dayjs | null = null;
            let refBeginDate: Dayjs | null = null;
            let prevSCDate: Dayjs | null = null;

            // Get the referral begin date
            if (response.demographics.referralDate) {
              refBeginDate = dayjs(response.demographics.referralDate);
              calculatedMinDate = refBeginDate;
            }

            // Check if there's a previous SC start date
            if (
              response.demographics.serviceCoordinatorHistory &&
              response.demographics.serviceCoordinatorHistory.length > 0
            ) {
              if (
                response.demographics.serviceCoordinatorHistory.length === 1
              ) {
                calculatedMinDate = dayjs(response.demographics.referralDate);
              } else {
                const sortedHistory = [
                  ...response.demographics.serviceCoordinatorHistory,
                ].sort((a, b) => {
                  const dateA = a.startTime ? dayjs(a.startTime) : dayjs(0);
                  const dateB = b.startTime ? dayjs(b.startTime) : dayjs(0);
                  return dateB.diff(dateA);
                });
                const latestSC = sortedHistory[0];
                if (latestSC.startTime) {
                  prevSCDate = dayjs(latestSC.startTime);
                  // Use the later of the two dates
                  if (
                    !calculatedMinDate ||
                    prevSCDate.isAfter(calculatedMinDate)
                  ) {
                    calculatedMinDate = prevSCDate;
                  }
                }
              }
            }

            setReferralBeginDate(refBeginDate);
            setPreviousSCStartDate(prevSCDate);
            setMinServiceCoordinatorDate(calculatedMinDate);

            handleRolesList(response);

            if (response.demographics) {
              const responseValues = {
                intakeCoordinator: response.demographics.intakeCoordinator,
                serviceCoordinator: response.demographics.serviceCoordinator,
                serviceCoordinatorStartDate:
                  response.demographics.serviceCoordinatorStartDate,
                referralDiagnosisCode:
                  response.demographics.diagnosis?.code ?? '',
                beginDate: response.demographics.beginDate,
                rollOverDate: response.demographics.rollOverDate,
                assessmentHoursDec: response.demographics.assessmentHoursDec,
                noOfAssessmentHoursUsedDec:
                  response.demographics.noOfAssessmentHoursUsedDec,
                remainingAssessmentHoursDec:
                  response.demographics.remainingAssessmentHoursDec,
                isSecondaryProgramServices:
                  response.demographics.isSecondaryProgramServices,
                eicsConsentToAccessInsurance:
                  response.demographics.eicsConsentToAccessInsurance,
                consentToAccessStartDate:
                  response.demographics.consentToAccessStartDate === null &&
                  response.demographics.eicsConsentToAccessInsurance === 0
                    ? response.demographics.referralDate
                    : response.demographics.consentToAccessStartDate,
                referralBeginDate: response.demographics.referralDate,
                ifspDueDate: response.demographics.ifspDueDate,
                referralType: response.demographics.referralType,
                elProgram: response.demographics.elProgram
                  ? response.demographics.elProgram
                  : '',
                elContactNumber: response.demographics.elContactNumber
                  ? response.demographics.elContactNumber
                  : '',
                eligibilityDate: response.demographics.eligibilityDate ?? null,
                povertyLevel: response.demographics.povertyLevel,
                referralContact: response.demographics.referralContact ?? [
                  {
                    id: '',
                    referralContactDate: null,
                    referralContactPhone: '',
                    referralContactFax: '',
                    referralContactEmail: '',
                    referralContactType: 'Referral Contact',
                    referralContactJobTitle: '',
                    referralContactName: '',
                    referralSource: '',
                    referralReason: '',
                    isDcf: false,
                    notes: '',
                  },
                ],
              };
              setFaceSheetForm({ ...responseValues });

              faceSheetFormBkp.current = JSON.parse(
                JSON.stringify(responseValues),
              );

              const filteredDiagnosisList: DiagnosisOptionType[] = [];

              filteredDiagnosisCodeList.forEach((codeDetails) => {
                if (codeDetails.id === response.demographics.diagnosis?.code) {
                  filteredDiagnosisList.push(codeDetails);
                }
                if (!codeDetails.isDeleted) {
                  filteredDiagnosisList.push(codeDetails);
                }
              });

              // remove duplicates in filteredDiagnosisList
              const uniqueDiagnosisList = filteredDiagnosisList.filter(
                (item, index) => {
                  return filteredDiagnosisList.indexOf(item) === index;
                },
              );

              uniqueDiagnosisList.sort((a, b) => {
                if (a.id < b.id) return -1;
                if (a.id > b.id) return 1;
                return 0;
              });

              const soertedLIst = uniqueDiagnosisList;

              setDiagnosisCodesList(soertedLIst);

              const selected: OptionType | undefined = uniqueDiagnosisList.find(
                (d) => d.id === response.demographics.diagnosis?.code,
              );
              if (selected) setSelectedDiagnosisCodesList(selected);
            }
            const referralsData = localStorage.getItem('clientReferralDetails');
            const referrals = referralsData
              ? (JSON.parse(referralsData) as ReferralResponseType[])
              : [];
            for (const referral of referrals) {
              if (referral.referralId === response.demographics.referralId) {
                localStorage.setItem(REFERRAL_PROGRAM_KEY, referral.programId);
                break;
              }
            }
            localStorage.setItem(
              REFERRAL_STATUS_KEY,
              response.demographics.status,
            );
          }
          toggleLoader(false);
        })
        .catch((error) => {
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('Client.error');
            setToastrDefaultMessage(error);
          }
        });
    }
  };

  const handleAddLink = () => {
    const newReferralContact = {
      id: '',
      referralContactDate: null,
      referralContactPhone: '',
      referralContactFax: '',
      referralContactEmail: '',
      referralContactType: 'Referral Contact',
      referralContactJobTitle: '',
      referralContactName: '',
      referralSource: '',
      referralReason: '',
      isDcf: false,
      notes: '',
    };

    const updatedReferralContact = {
      ...faceSheetForm,
      referralContact: [...faceSheetForm.referralContact, newReferralContact],
    };

    formikRef.current?.setValues(updatedReferralContact);

    setFaceSheetForm(updatedReferralContact);
  };

  const handleDeleteLink = (ind: number) => {
    if (faceSheetForm.referralContact.length > 1) {
      const updatedReferralContact = [...faceSheetForm.referralContact]; // Correctly copy the array
      updatedReferralContact.splice(ind, 1); // Remove the element at index 'ind'

      const updatedDataView = {
        ...faceSheetForm,
        referralContact: updatedReferralContact,
      };

      formikRef.current?.setValues(updatedDataView);
      setFaceSheetForm(updatedDataView);
    }
  };

  const handleValueUpdates = (
    indexNo: number,
    name: keyof ReferralContactJsonType,
    value: string | null | boolean,
  ) => {
    const updatedReferralContact = [...faceSheetForm.referralContact];
    (updatedReferralContact[indexNo][name] as string | null | boolean) = value;
    const updatedDataView = {
      ...faceSheetForm,
      referralContact: updatedReferralContact,
    };

    setFaceSheetForm(updatedDataView);
  };

  const handleCloseModal = () => {
    formikRef.current?.setValues(faceSheetFormBkp.current, true);
    setSelectedIntakeCoordinator(null);
    setSelectedServiceCoordinator(null);
    setSelectedDiagnosisCodesList(null);
    setFaceSheetForm(faceSheetFormBkp.current);
    setFormDialogFlag(false);
  };

  const handleNewReferral = () => {
    setReferralFormDialogFlag(true);
  };

  const dateExtension = (date: string) => {
    const originalDate = new Date(date);
    originalDate.setDate(originalDate.getDate() + 45);
    const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
    const day = originalDate.getDate().toString().padStart(2, '0');
    const year = originalDate.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleRereferralFormSubmit = useCallback(
    debounce((reReferralData: AddReReferralFaceSheet) => {
      handleRereferralApiCall(reReferralData);
    }, 500),
    [],
  );

  const handleRereferralApiCall = async (
    reReferralData: AddReReferralFaceSheet,
  ) => {
    if (clientId) {
      toggleLoader(true);
      await addReReferral(reReferralData, clientId)
        .then(async (response) => {
          if (response) {
            setOpen(true);
            setToastrVariable('success');
            setToastrId('Facesheet.referralAddedSuccessfully');
            setToastrDefaultMessage('Referral added successfully');
            setDcfChecked(false);
            setReferralFormDialogFlag(false);

            setSelectedDphId(response.referralId);
            localStorage.setItem(REFERRAL_ID_KEY, response.referralId);
            localStorage.setItem('defaultReferralId', response.referralId);

            await handleDiagnosisDataGetAPI();

            await fetchRefferralDetails(response.referralId);

            await fetchFaceSheetDetails(diagnosisCodesList);
          }
        })
        .catch((error) => {
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else if (error.code === 1058) {
            setToastrId('Facesheet.apiErrorMsg');
            setToastrDefaultMessage(error.message);
          } else if (error.code === 1120) {
            setToastrId('Facesheet.apiExceptionErrorMsg');
            setToastrDefaultMessage(error.message);
          } else {
            setToastrId('Client.error');
            setToastrDefaultMessage(error.message);
          }
          toggleLoader(false);
        });
    }
  };

  return (
    <Box component="main">
      {selectedFile && showPreview && (
        <FilePreviewDialog
          url={selectedFile.resourceUrl}
          fileName={'resources/'.concat(selectedFile.name).concat('.pdf')}
          onClose={() => {
            setShowPreview(false);
            setSelectedFile(undefined);
          }}
        />
      )}
      <Box component="section">
        <SnackBarComponent
          open={open}
          handleClose={handleClose}
          successOrError={toastrVariable}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
        />

        <ModalPopup
          open={serviceCoordinatorValidation}
          description="serviceCoordinatorValidation"
          labelId1="serviceCoordinatorValidationNo"
          labelId2="serviceCoordinatorValidationYes"
          negativeActionLabel="No"
          positiveActionLabel="Yes"
          sxProps={{
            position: 'fixed',
            zIndex: (theme) => theme.zIndex.modal + 10,
          }}
          onCancel={() => {
            setServiceCoordinatorValidation(false);
          }}
          onOk={() => {
            if (faceshettFormValue.current) {
              formSubmit(faceshettFormValue.current);
            }
          }}
        />

        {faceSheetDetails && (
          <Dialog open={serviceDialogFlag} fullWidth maxWidth="sm">
            <DialogTitle>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', // Align items vertically in the center
                }}
              >
                <MediumTypography
                  labelid={'Facesheet.serviceCoordinators'}
                  sxProps={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginTop: '8px',
                  }}
                  defaultlabel="Service Coordinators"
                />
                <Close
                  style={{
                    marginLeft: 'auto', // Move the Close button to the right side
                    marginTop: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => setServiceDialogFlag(false)}
                />
              </Box>
            </DialogTitle>
            <DialogContent>
              {faceSheetDetails.demographics.serviceCoordinatorHistory.map(
                (eventProps: ServiceCoordinatorsType) => {
                  return (
                    <Box sx={{ marginY: '8px' }} key={eventProps.id}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            fontFamily: 'Lato-Regular',
                            color: '#2A4241',
                          }}
                        >
                          {eventProps.firstName} {eventProps.lastName}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            fontFamily: 'Lato-Regular',
                            color: '#97A6A5',
                          }}
                        >
                          {moment(eventProps.startTime, 'MM/DD/YYYY').format(
                            'MMM DD, YYYY',
                          )}{' '}
                          -{' '}
                          {eventProps.endTime
                            ? moment(eventProps.endTime, 'MM/DD/YYYY').format(
                                'MMM DD, YYYY',
                              )
                            : 'Present'}
                        </Typography>
                      </Box>
                      <Box
                        className="horizontalLine"
                        sx={{ marginY: '12px' }}
                      />
                    </Box>
                  );
                },
              )}
            </DialogContent>
          </Dialog>
        )}

        {faceSheetDetails && (
          <Dialog open={intakeDialogFlag} fullWidth maxWidth="sm">
            <DialogTitle>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', // Align items vertically in the center
                }}
              >
                <MediumTypography
                  labelid={'Facesheet.intakeFacilitators'}
                  sxProps={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginTop: '8px',
                  }}
                  defaultlabel="Intake Facilitators"
                />
                <Close
                  style={{
                    marginLeft: 'auto', // Move the Close button to the right side
                    marginTop: '8px',
                    cursor: 'pointer',
                  }}
                  onClick={() => setIntakeDialogFlag(false)}
                />
              </Box>
            </DialogTitle>
            <DialogContent>
              {faceSheetDetails.demographics.intakeCoordinatorHistory.map(
                (eventProps: IntakeCoordinatorsType) => {
                  return (
                    <Box sx={{ marginY: '8px' }} key={eventProps.id}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            fontFamily: 'Lato-Regular',
                            color: '#2A4241',
                          }}
                        >
                          {eventProps.firstName} {eventProps.lastName}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '14px',
                            fontWeight: 500,
                            fontFamily: 'Lato-Regular',
                            color: '#97A6A5',
                          }}
                        >
                          {moment(eventProps.startTime, 'YYYY-MM-DD HH:mm:ss')
                            .utc(true)
                            .local()
                            .format('MMM DD, YYYY')}{' '}
                          -{' '}
                          {eventProps.endTime
                            ? moment(eventProps.endTime, 'YYYY-MM-DD HH:mm:ss')
                                .utc(true)
                                .local()
                                .format('MMM DD, YYYY')
                            : 'Present'}
                        </Typography>
                      </Box>

                      <Box
                        className="horizontalLine"
                        sx={{ marginY: '12px' }}
                      />
                    </Box>
                  );
                },
              )}
            </DialogContent>
          </Dialog>
        )}

        {faceSheetDetails && (
          <Dialog open={formDialogFlag} fullWidth maxWidth="md">
            <DialogTitle>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', // Align items vertically in the center
                }}
              >
                <Tooltip
                  title={formatName(
                    faceSheetDetails.demographics.firstName,
                    faceSheetDetails.demographics.middleName,
                    faceSheetDetails.demographics.lastName,
                    faceSheetDetails.demographics.suffix,
                  )}
                  arrow
                >
                  <Box sx={{ display: 'flex' }}>
                    <Box>
                      <MediumTypography
                        label={'Referral Information - '}
                        sxProps={{
                          fontSize: '20px',
                          fontWeight: 'bold',
                          width: '100%',
                          marginRight: '4px',
                        }}
                      />
                    </Box>
                    <Box>
                      <MediumTypography
                        label={formatName(
                          faceSheetDetails.demographics.firstName,
                          faceSheetDetails.demographics.middleName,
                          faceSheetDetails.demographics.lastName,
                          faceSheetDetails.demographics.suffix,
                        )}
                        sxProps={{
                          fontSize: '20px',
                          maxWidth: '500px',
                          width: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      />
                    </Box>
                  </Box>
                </Tooltip>
              </Box>
            </DialogTitle>
            <Formik
              innerRef={formikRef}
              initialValues={faceSheetForm}
              enableReinitialize={true}
              validateOnBlur={true}
              validateOnChange={false}
              validationSchema={validationSchema}
              validate={validateForm}
              onSubmit={(values) => {
                handleFormSubmit(values);
              }}
            >
              {({
                values,
                setFieldValue,
                errors,
                touched,
                handleSubmit,
                handleBlur,
              }) => (
                <>
                  <DialogContent onBlur={handleBlur}>
                    <Box
                      component="div"
                      onBlur={handleBlur}
                      style={{
                        pointerEvents: hasEditPermission ? 'auto' : 'none',
                        opacity: hasEditPermission ? 'unset' : '0.8',
                      }}
                    >
                      <Grid container direction={'row'} spacing={2}>
                        <Grid item xs={6} style={{ paddingTop: '12px' }}>
                          <CheckBoxComponent
                            ischecked={values.isSecondaryProgramServices}
                            labelid="secondaryProgramServiceText"
                            defaultlabelid="Secondary Program Service"
                            CheckHandleChange={(
                              event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              setFieldValue(
                                'isSecondaryProgramServices',
                                event.target.checked,
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6} />
                        <Grid item xs={6}>
                          <AutocompleteSearch
                            labelId={'Facesheet.intakeFacilitator'}
                            defaultId="Intake Facilitator"
                            optionHintId={'nointakeDropdownTextId'}
                            sxProps={{
                              [`& .${autocompleteClasses.popupIndicator}`]: {
                                transform: 'none',
                              },
                            }}
                            data={intakeCoordinatorsList}
                            selectedValue={
                              selectedIntakeCoordinator ?? { id: '', label: '' }
                            }
                            onSelectItem={(value: OptionType | null) => {
                              if (value) {
                                setSelectedIntakeCoordinator(value);
                                setFieldValue('intakeCoordinator', value.id);
                              }
                            }}
                            disableLabel={false}
                          />
                        </Grid>

                        <Grid item xs={6} />

                        <Grid item xs={6}>
                          <AutocompleteSearch
                            labelId={'Facesheet.serviceCoordinator'}
                            defaultId="Service Coordinator"
                            optionHintId={'noserviceDropdownTextId'}
                            sxProps={{
                              [`& .${autocompleteClasses.popupIndicator}`]: {
                                transform: 'none',
                              },
                            }}
                            data={serviceCoordinatorsList}
                            selectedValue={
                              selectedServiceCoordinator ?? {
                                id: '',
                                label: '',
                              }
                            }
                            onSelectItem={(value: OptionType | null) => {
                              if (value) {
                                const history =
                                  faceSheetDetails.demographics
                                    .serviceCoordinatorHistory;
                                if (history.length === 1) {
                                  const coordinator = history.at(-1);
                                  if (coordinator?.id === value.id) {
                                    setMinServiceCoordinatorDate(
                                      dayjs(
                                        faceSheetDetails.demographics
                                          .referralDate,
                                        'MM/DD/YYYY',
                                      ),
                                    );
                                  } else {
                                    setMinServiceCoordinatorDate(
                                      dayjs(
                                        coordinator?.startTime,
                                        'MM/DD/YYYY',
                                      ),
                                    );
                                  }
                                } else if (history.length > 1) {
                                  setMinServiceCoordinatorDate(
                                    dayjs(history[0].startTime, 'MM/DD/YYYY'),
                                  );
                                }

                                setSelectedServiceCoordinator(value);
                                setFieldValue('serviceCoordinator', value.id);
                                setFieldValue(
                                  'serviceCoordinatorStartDate',
                                  null,
                                );
                                setScStartDateError('');
                              }
                            }}
                            disableLabel={false}
                          />
                        </Grid>

                        <Grid item xs={6} lg={6}>
                          <DatePickerComponent
                            disabledDate={!values.serviceCoordinator}
                            value={
                              values.serviceCoordinatorStartDate === null
                                ? null
                                : dayjs(values.serviceCoordinatorStartDate)
                            }
                            labelid="serviceCoordinatorStartDateText"
                            defaultlabelid="Service Coordinator Start Date"
                            minDate={minServiceCoordinatorDate || undefined}
                            maxDate={dayjs()}
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setScStartDateError('');
                                formikRef.current?.setValues({
                                  ...values,
                                  serviceCoordinatorStartDate: null,
                                });
                              } else {
                                // Validate against minimum and maximum dates
                                if (date.isAfter(dayjs(), 'day')) {
                                  setScStartDateError(
                                    'futureDateNotAllowedValidation',
                                  );
                                } else if (
                                  previousSCStartDate &&
                                  date.isBefore(previousSCStartDate, 'day')
                                ) {
                                  // Check previous SC date first (more specific)
                                  setScStartDateError(
                                    'serviceCoordinatorStartDateBeforePreviousSCError',
                                  );
                                } else if (
                                  referralBeginDate &&
                                  date.isBefore(referralBeginDate, 'day')
                                ) {
                                  // Check referral begin date
                                  setScStartDateError(
                                    'serviceCoordinatorStartDateBeforeReferralError',
                                  );
                                } else {
                                  setScStartDateError('');
                                }
                                formikRef.current?.setValues({
                                  ...values,
                                  serviceCoordinatorStartDate: formattedDate,
                                });
                              }
                            }}
                            required={values.serviceCoordinator !== ''}
                          />
                          {scStartDateError && (
                            <MediumTypography
                              labelid={scStartDateError}
                              className="errorText-md"
                            />
                          )}
                          {!scStartDateError &&
                            errors.serviceCoordinatorStartDate &&
                            touched.serviceCoordinatorStartDate && (
                              <MediumTypography
                                labelid={errors.serviceCoordinatorStartDate}
                                className="errorText-md"
                              />
                            )}
                        </Grid>

                        <Grid item xs={6} lg={6}>
                          <DatePickerComponent
                            value={dayjs(values.referralBeginDate)}
                            labelid="AddNewReferralDetails.referralBeginDate"
                            defaultlabelid="Referral Begin Date"
                            maxDate={dayjs()}
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                formikRef.current?.setValues({
                                  ...values,
                                  referralBeginDate: null,
                                  // ifspDueDate: null,
                                });
                              } else {
                                formikRef.current?.setValues({
                                  ...values,
                                  referralBeginDate: formattedDate,
                                  // ifspDueDate: dateExtension(formattedDate),
                                });

                                // Recalculate minimum SC date when referral begin date changes
                                let newMinDate: Dayjs | null = date;
                                setReferralBeginDate(date);

                                // Check if there's a previous SC start date that's later
                                if (
                                  faceSheetDetails?.demographics
                                    .serviceCoordinatorHistory &&
                                  faceSheetDetails.demographics
                                    .serviceCoordinatorHistory.length > 0
                                ) {
                                  const sortedHistory = [
                                    ...faceSheetDetails.demographics
                                      .serviceCoordinatorHistory,
                                  ].sort((a, b) => {
                                    const dateA = a.startTime
                                      ? dayjs(a.startTime)
                                      : dayjs(0);
                                    const dateB = b.startTime
                                      ? dayjs(b.startTime)
                                      : dayjs(0);
                                    return dateB.diff(dateA);
                                  });
                                  const latestSC = sortedHistory[0];
                                  if (latestSC.startTime) {
                                    const latestSCDate = dayjs(
                                      latestSC.startTime,
                                    );
                                    if (latestSCDate.isAfter(newMinDate)) {
                                      newMinDate = latestSCDate;
                                    }
                                  }
                                }

                                setMinServiceCoordinatorDate(newMinDate);

                                // Clear SC start date error if it exists
                                setScStartDateError('');
                              }
                            }}
                            required={true}
                          />
                          {errors.referralBeginDate &&
                            touched.referralBeginDate && (
                              <MediumTypography
                                labelid={errors.referralBeginDate}
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        direction={'row'}
                        className="pt-md"
                        spacing={2}
                      >
                        <Grid item xs={12} lg={12}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <MediumTypography
                              labelid="AddNewReferralDetails.referralType"
                              defaultlabel="Referral Type"
                              sxProps={{
                                color: '#2A4241',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                marginRight: '16px',
                              }}
                            />
                            <CustomRadioButton
                              data={referralTypeOptions}
                              value={values.referralType}
                              onSelectItem={(value) => {
                                if (value !== null) {
                                  setFieldValue('referralType', value);
                                  if (value !== 'Incoming Transfer') {
                                    setFieldValue('elProgram', '');
                                    setFieldValue('elContactNumber', '');
                                    setFieldValue(
                                      'remainingAssessmentHoursDec',
                                      null,
                                    );
                                    setFieldValue('beginDate', null);
                                    setFieldValue('eligibilityDate', '');
                                    setFieldValue('rollOverDate', null);
                                  }
                                }
                              }}
                              disable
                            />
                          </Box>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        className="pt-md"
                        direction={'row'}
                        spacing={2}
                      >
                        <Grid item xs={6}>
                          <AutocompleteSearch
                            textDecoration={
                              selectedDiagnosisCodesList?.label.includes('- *')
                                ? 'underline'
                                : 'none'
                            }
                            labelId={'referralDiagnosisCodeText'}
                            defaultId="Referral Diagnosis Code"
                            optionHintId={'noReferralDropdownTextId'}
                            renderOption={(props, option: OptionType) => {
                              const parts = option.label.split(' - ');
                              let beforeHyphen = '';
                              let afterHyphen = '';

                              if (parts.length > 1) {
                                beforeHyphen = parts[0];
                                afterHyphen = parts?.slice(1)?.join(' - ');
                              } else {
                                beforeHyphen = option.label;
                              }

                              const underlineStyle = afterHyphen.includes('*')
                                ? 'underline'
                                : 'none';

                              return (
                                <li {...props}>
                                  {parts.length > 1 ? (
                                    <Box className="flex__">
                                      <Box className="whiteSpacePre mr-sm">
                                        {beforeHyphen} &nbsp; -
                                      </Box>
                                      <Box
                                        style={{
                                          textDecoration: underlineStyle,
                                        }}
                                      >
                                        {afterHyphen}
                                      </Box>
                                    </Box>
                                  ) : (
                                    <span
                                      style={{
                                        textDecoration: underlineStyle,
                                      }}
                                    >
                                      {beforeHyphen}
                                    </span>
                                  )}
                                </li>
                              );
                            }}
                            sxProps={{
                              [`& .${autocompleteClasses.popupIndicator}`]: {
                                transform: 'none',
                              },
                              backgroundColor: 'white',
                            }}
                            data={diagnosisCodesList}
                            selectedValue={
                              selectedDiagnosisCodesList ?? {
                                id: '',
                                label: '',
                              }
                            }
                            onSelectItem={(value: OptionType | null) => {
                              if (value === null) {
                                setSelectedDiagnosisCodesList(null);
                                setFieldValue('referralDiagnosisCode', '');
                              } else {
                                setSelectedDiagnosisCodesList(value);
                                setFieldValue(
                                  'referralDiagnosisCode',
                                  value.id,
                                );
                              }
                            }}
                            disableLabel={false}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        direction={'row'}
                        spacing={2}
                        className="mt-sm"
                      >
                        <Grid item xs={12} lg={12}>
                          <Box>
                            <MediumTypography
                              labelid="eicsConsentToAccessInsuranceText"
                              defaultlabel="EICS Consent To Access Insurance"
                              sxProps={{
                                fontWeight: 'bold',
                                fontSize: '14px',
                                marginBottom: '8px',
                              }}
                            />
                            <CustomRadioButton
                              data={eicsConcentValues}
                              value={values.eicsConsentToAccessInsurance.toString()}
                              onSelectItem={(value) => {
                                if (value !== null) {
                                  setFieldValue(
                                    'eicsConsentToAccessInsurance',
                                    parseInt(value),
                                  );
                                  setFieldValue(
                                    'consentToAccessStartDate',
                                    dayjs().format('MM/DD/YYYY'),
                                  );
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={4} lg={4} sx={{ marginTop: '-8px' }}>
                          <DatePickerComponent
                            labelid="consentDateText"
                            defaultlabelid="Insurance Consent Date"
                            value={dayjs(values.consentToAccessStartDate)}
                            required={true}
                            handlechange={(date) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setFieldValue('consentToAccessStartDate', null);
                              } else {
                                setFieldValue(
                                  'consentToAccessStartDate',
                                  formattedDate,
                                );
                              }
                            }}
                          />
                          {errors.consentToAccessStartDate &&
                            touched.consentToAccessStartDate && (
                              <MediumTypography
                                labelid={errors.consentToAccessStartDate}
                                defaultlabel="Insurance consent date is required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        direction={'row'}
                        spacing={2}
                        className="pt-md"
                      >
                        <Grid item xs={12} lg={12}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <MediumTypography
                              className="mb-sm"
                              labelid="Facesheet.povertyLevelTitle"
                              defaultlabel="Poverty Level"
                              sxProps={{
                                color: '#2A4241',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                marginRight: '16px',
                              }}
                            />
                            {resourceData?.resourceUrl && (
                              <Document
                                style={{
                                  width: '15px',
                                  marginBottom: 'auto',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  const extension = resourceData?.resourceUrl
                                    ? extractFileExtension(
                                        resourceData.resourceUrl,
                                      ).toLowerCase()
                                    : '';
                                  if (
                                    PREVIEW_DOCUMENT_EXTENSIONS.includes(
                                      extension,
                                    )
                                  ) {
                                    handlePreviewClick(resourceData);
                                  }
                                }}
                              />
                            )}
                          </Box>
                          <CustomRadioButton
                            data={PovertyJsonData}
                            value={values.povertyLevel}
                            onSelectItem={(value) => {
                              if (value) {
                                setFieldValue('povertyLevel', value);
                              }
                            }}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        direction={'row'}
                        spacing={2}
                        className="pt-md pb-md"
                      >
                        <Grid item xs={12} lg={12}>
                          <MediumTypography
                            labelid="AddNewReferralDetails.referalContactText"
                            defaultlabel="Referral Contact"
                            sxProps={{
                              color: '#2A4241',
                              fontWeight: 'bold',
                              fontSize: '14px',
                              marginRight: '16px',
                            }}
                          />
                        </Grid>
                      </Grid>

                      {faceSheetForm.referralContact.map((__, index) => (
                        <>
                          <Box
                            className="p-md gray3 borderRadius4"
                            sx={{
                              border: '1px solid #00C6B8',
                            }}
                          >
                            <Grid
                              container
                              direction={'row'}
                              spacing={2}
                              key={`referralContact-${index + 1}`}
                            >
                              <Grid item xs={6} lg={6}>
                                <Textinput
                                  name="referralContactName"
                                  labelid="AddNewReferralDetails.Name"
                                  defaultlabelid="Name"
                                  Value={
                                    values.referralContact[index]
                                      .referralContactName
                                  }
                                  inputProps={{
                                    maxLength: 50,
                                  }}
                                  handlechange={(value: string) => {
                                    const validatedValue =
                                      nameValidation(value);
                                    if (validatedValue !== undefined) {
                                      setFieldValue(
                                        `referralContact[${index}].referralContactName`,
                                        validatedValue,
                                      );
                                      handleValueUpdates(
                                        index,
                                        'referralContactName',
                                        validatedValue,
                                      );
                                    }
                                  }}
                                  sxProps={{
                                    backgroundColor: 'white',
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>

                              <Grid item xs={6} lg={6}>
                                <Textinput
                                  name="referralContactJobTitle"
                                  Value={
                                    values.referralContact[index]
                                      .referralContactJobTitle
                                  }
                                  labelid="AddNewReferralDetails.JobTitle"
                                  defaultlabelid="Job Title"
                                  inputProps={{
                                    maxLength: 50,
                                  }}
                                  handlechange={(value: string) => {
                                    const validatedValue =
                                      nameValidation(value);
                                    if (validatedValue !== undefined) {
                                      setFieldValue(
                                        `referralContact[${index}].referralContactJobTitle`,
                                        validatedValue,
                                      );
                                      handleValueUpdates(
                                        index,
                                        'referralContactJobTitle',
                                        validatedValue,
                                      );
                                    }
                                  }}
                                  sxProps={{
                                    backgroundColor: 'white',
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                              <Grid item xs={6} lg={6} className="pt-none">
                                <Box component="div" className="flex__ mt-sm">
                                  <CheckBoxComponent
                                    ischecked={
                                      values.referralContact[index].isDcf
                                    }
                                    CheckHandleChange={(value) => {
                                      setFieldValue(
                                        `referralContact[${index}].isDcf`,
                                        value.target.checked,
                                      );
                                      handleValueUpdates(
                                        index,
                                        'isDcf',
                                        value.target.checked,
                                      );
                                    }}
                                    labelid="AddNewReferralDetails.DCF"
                                    defaultlabelid="DCF"
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={6} lg={6}></Grid>

                              <Grid item xs={6} lg={6}>
                                <DatePickerComponent
                                  value={
                                    dayjs(
                                      values.referralContact[index]
                                        .referralContactDate,
                                    ) ?? null
                                  }
                                  labelid="AddNewReferralDetails.referralDate"
                                  disableFuture={true}
                                  minDate={dayjs(
                                    faceSheetDetails.demographics.dateOfBirth,
                                  )}
                                  defaultlabelid="Referral Contact Date"
                                  handlechange={(date: Dayjs | null) => {
                                    const formattedDate =
                                      dayjs(date).format('MM/DD/YYYY');
                                    if (date === null) {
                                      setFieldValue(
                                        `referralContact[${index}].referralContactDate`,
                                        null,
                                      );
                                      handleValueUpdates(
                                        index,
                                        'referralContactDate',
                                        null,
                                      );
                                    } else {
                                      setFieldValue(
                                        `referralContact[${index}].referralContactDate`,
                                        formattedDate,
                                      );
                                      handleValueUpdates(
                                        index,
                                        'referralContactDate',
                                        formattedDate,
                                      );
                                    }
                                  }}
                                  required={true}
                                  className="bg__white"
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                                {errors.referralContact?.[index] &&
                                  (
                                    errors.referralContact[
                                      index
                                    ] as FormikErrors<ReferralContactJsonType>
                                  ).referralContactDate &&
                                  touched.referralContact?.[index]
                                    ?.referralContactDate && (
                                    <MediumTypography
                                      labelid={
                                        (
                                          errors.referralContact[
                                            index
                                          ] as FormikErrors<ReferralContactJsonType>
                                        ).referralContactDate
                                      }
                                      className="errorText-md"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={6} lg={6}>
                                <DropdownComponent
                                  Required
                                  names={referralSources}
                                  labelid="AddNewReferralDetails.referralSource"
                                  defaultlabelid="Referral Source"
                                  value={
                                    values.referralContact[index].referralSource
                                  }
                                  handleChange={(value) => {
                                    setFieldValue(
                                      `referralContact[${index}].referralSource`,
                                      value,
                                    );
                                    handleValueUpdates(
                                      index,
                                      'referralSource',
                                      value,
                                    );
                                  }}
                                  disabled={!hasEditPermission}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                                {errors.referralContact?.[index] &&
                                  (
                                    errors.referralContact[
                                      index
                                    ] as FormikErrors<ReferralContactJsonType>
                                  ).referralSource &&
                                  touched.referralContact?.[index]
                                    ?.referralSource && (
                                    <MediumTypography
                                      labelid={
                                        (
                                          errors.referralContact[
                                            index
                                          ] as FormikErrors<ReferralContactJsonType>
                                        ).referralSource
                                      }
                                      defaultlabel="Referral Source is Required"
                                      className="errorText-md"
                                    />
                                  )}
                              </Grid>

                              <Grid item xs={6} lg={6}>
                                <DropdownComponent
                                  Required
                                  names={referralReasons}
                                  labelid="AddNewReferralDetails.referralReason"
                                  defaultlabelid="Referral Reason"
                                  value={
                                    values.referralContact[index].referralReason
                                  }
                                  handleChange={(value) => {
                                    setFieldValue(
                                      `referralContact[${index}].referralReason`,
                                      value,
                                    );
                                    handleValueUpdates(
                                      index,
                                      'referralReason',
                                      value,
                                    );
                                  }}
                                  disabled={!hasEditPermission}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />

                                {errors.referralContact?.[index] &&
                                  (
                                    errors.referralContact[
                                      index
                                    ] as FormikErrors<ReferralContactJsonType>
                                  ).referralReason &&
                                  touched.referralContact?.[index]
                                    ?.referralReason && (
                                    <MediumTypography
                                      labelid={
                                        (
                                          errors.referralContact[
                                            index
                                          ] as FormikErrors<ReferralContactJsonType>
                                        ).referralReason
                                      }
                                      defaultlabel="Referral Reason is Required"
                                      className="errorText-md"
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={6} lg={6}>
                                <Textinput
                                  name="referralContactEmail"
                                  Value={
                                    values.referralContact[index]
                                      .referralContactEmail
                                  }
                                  labelid="AddNewReferralDetails.Email"
                                  defaultlabelid="Email"
                                  Required={false}
                                  inputProps={{
                                    maxLength: 50,
                                  }}
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `referralContact[${index}].referralContactEmail`,
                                      value,
                                    );
                                    handleValueUpdates(
                                      index,
                                      'referralContactEmail',
                                      value,
                                    );
                                  }}
                                  sxProps={{
                                    backgroundColor: 'white',
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>

                              <Grid item xs={6} lg={6}>
                                <Textinput
                                  name="referralContactPhone"
                                  Value={
                                    values.referralContact[index]
                                      .referralContactPhone
                                  }
                                  labelid="AddNewReferralDetails.referralPhone"
                                  defaultlabelid="Phone"
                                  inputProps={{
                                    maxLength: 50,
                                  }}
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `referralContact[${index}].referralContactPhone`,
                                      formatPhoneNumber(value),
                                    );
                                    handleValueUpdates(
                                      index,
                                      'referralContactPhone',
                                      value,
                                    );
                                  }}
                                  sxProps={{
                                    backgroundColor: 'white',
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                              <Grid item xs={6} lg={6}>
                                <Textinput
                                  name="referralContactFax"
                                  Value={
                                    values.referralContact[index]
                                      .referralContactFax
                                  }
                                  labelid="AddNewReferralDetails.Fax"
                                  defaultlabelid="Fax"
                                  Required={false}
                                  inputProps={{
                                    maxLength: 50,
                                  }}
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `referralContact[${index}].referralContactFax`,
                                      formatPhoneNumber(value),
                                    );
                                    handleValueUpdates(
                                      index,
                                      'referralContactFax',
                                      value,
                                    );
                                  }}
                                  sxProps={{
                                    backgroundColor: 'white',
                                  }}
                                  placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>

                              <Grid item xs={12} lg={12}>
                                <CommentTextbox
                                  name="notes"
                                  placeholder={rctl.formatMessage({
                                    id: 'AddNewReferralDetails.notes',
                                    defaultMessage: 'Notes',
                                  })}
                                  Value={values.referralContact[index].notes}
                                  maxLength={2000}
                                  handlechange={(value: string) => {
                                    setFieldValue(
                                      `referralContact[${index}].notes`,
                                      value,
                                    );
                                    handleValueUpdates(index, 'notes', value);
                                  }}
                                  placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                                />
                              </Grid>
                            </Grid>
                          </Box>

                          <Box className="flex__">
                            {index === values.referralContact.length - 1 &&
                              values.referralContact.length < 3 && (
                                <Grid
                                  container
                                  justifyContent="space-between"
                                  alignItems="center"
                                  className="mt-sm mb-sm"
                                  visibility={
                                    hasEditPermission ? 'visible' : 'hidden'
                                  }
                                >
                                  <Grid item>
                                    <ButtonComponent
                                      className="btn-add-code"
                                      variantType="contained"
                                      type="submit"
                                      labelId="Facesheet.anotherReferral"
                                      defaultLabelId="+ Add Another Referral Contact"
                                      onClick={() => handleAddLink()}
                                    />
                                  </Grid>
                                </Grid>
                              )}

                            {values.referralContact.length > 1 &&
                            (values.referralContact[index].id === '' ||
                              values.referralContact[index].id === null) ? (
                              <Grid
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                                className="mt-sm mb-sm"
                              >
                                <Grid item>
                                  <TextWithIcon
                                    LeftIcon={<DeleteIconBtn />}
                                    labelId="deleteText"
                                    defaultLabel="Delete"
                                    sxProps={{
                                      color: '#EB4C60',
                                      cursor: 'pointer',
                                      textDecoration: 'underline',
                                      fontSize: '14px',
                                      fontFamily: 'Lato-Regular',
                                      textTransform: 'none',
                                    }}
                                    onClick={() => handleDeleteLink(index)}
                                  />
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid
                                container
                                justifyContent="flex-end"
                                alignItems="center"
                                className="mt-sm mb-sm"
                              ></Grid>
                            )}
                          </Box>
                        </>
                      ))}
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Box
                      sx={{
                        margin: '12px',
                      }}
                      display={'flex'}
                      justifyContent={'flex-end'}
                    >
                      <ButtonComponent
                        className="btn-primary btn-cancel alrt_Width_btn mr-md"
                        variantType="contained"
                        labelId={'cancelText'}
                        defaultLabelId={'Cancel'}
                        onClick={() => {
                          if (!_.isEqual(faceSheetFormBkp.current, values)) {
                            setCancelModal(true);
                          } else {
                            setFormDialogFlag(false);
                          }
                        }}
                      />

                      <ButtonComponent
                        variantType="contained"
                        type="submit"
                        className="btn-primary btn-submit alrt_Width_btn"
                        labelId={'saveText'}
                        defaultLabelId={'Save'}
                        onClick={handleSubmit}
                        disabled={
                          _.isEqual(faceSheetFormBkp.current, values) ||
                          scStartDateError !== ''
                        }
                        sxProps={{
                          display: hasEditPermission ? 'auto' : 'none',
                        }}
                      />
                    </Box>
                  </DialogActions>
                </>
              )}
            </Formik>
          </Dialog>
        )}

        <Box className="rowContainer">
          <CustomBackArrow
            onClick={async () => {
              localStorage.removeItem('Demographics');
              localStorage.removeItem('clientName');
              localStorage.removeItem('clientReferralDetails');
              localStorage.removeItem(REFERRAL_STATUS_KEY);
              localStorage.removeItem(REFERRAL_PROGRAM_KEY);
              if (lookupsDemographics) {
                updateDemographics({
                  ...lookupsDemographics,
                  firstName: '',
                  middleName: '',
                  lastName: '',
                  suffix: '',
                  ageInMonths: null,
                  sex: null,
                  dateOfBirth: '',
                  dphId: null,
                });
              }
              navigation(CLIENTS_DASHBOARD_ROUTE_NAME);
            }}
          />
          <Box
            component="div"
            className="ml-md"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center', // Center items vertically
              width: '100%',
            }}
          >
            <Box>
              <TitleText
                labelid="Facesheet.Titletext"
                defaultlabel="Facesheet"
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box sx={{ flexGrow: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  {faceSheetDetails && (
                    <ButtonComponent
                      className="btn-primary btn-submit mr-md"
                      labelId="Referral.RereferralTitletext"
                      defaultLabelId="Add Re-Referral"
                      variantType="contained"
                      disabled={faceSheetDetails.activeReferral}
                      onClick={handleNewReferral}
                    />
                  )}
                </Box>
              </Box>
              {makedownload && (
                <Box
                  sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <DownloadIcon style={{ marginRight: '8px' }} />
                  <MediumTypography
                    labelid={'offlinedownloadtxt'}
                    defaultlabel={'Download offline'}
                    sxProps={{
                      color: '#008C82',
                      fontSize: '14px',
                      textAlign: 'justify',
                      marginRight: '24px',
                      whiteSpace: 'nowrap',
                    }}
                  />
                </Box>
              )}
              {deleteMakedownload && (
                <Box
                  onClick={deleteOfflineData}
                  sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <DeleteIcon style={{ marginRight: '8px' }} />
                  <MediumTypography
                    labelid={'offlinedeletetxt'}
                    defaultlabel={'Delete offline'}
                    sxProps={{
                      color: '#008C82',
                      fontSize: '14px',
                      textAlign: 'justify',
                      marginRight: '24px',
                      whiteSpace: 'nowrap',
                    }}
                  />
                </Box>
              )}
              {sync && (
                <Box
                  onClick={syncData}
                  sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <SyncIcon style={{ marginRight: '8px' }} />

                  <MediumTypography
                    labelid={'offlinesynctxt'}
                    defaultlabel={'Sync'}
                    sxProps={{
                      color: '#008C82',
                      fontSize: '14px',
                      textAlign: 'justify',
                      marginRight: '24px',
                      whiteSpace: 'nowrap',
                    }}
                  />
                </Box>
              )}
              <MediumTypography
                labelid={'Facesheet.DPHID'}
                defaultlabel={'Enrollment ID'}
                sxProps={{
                  color: '#00C6B8',
                  fontSize: '14px',
                  textAlign: 'justify',
                  marginRight: '5px',
                  whiteSpace: 'nowrap',
                }}
              />
              <DropdownComponent
                names={dphIdValues}
                value={selectedDphId || ''}
                handleChange={async (e) => {
                  setSelectedDphId(e ?? null);
                  localStorage.setItem(REFERRAL_ID_KEY, e ?? null);
                  const referralsData = localStorage.getItem(
                    'clientReferralDetails',
                  );
                  const referrals = referralsData
                    ? (JSON.parse(referralsData) as ReferralResponseType[])
                    : [];
                  for (const referral of referrals) {
                    if (referral.referralId === e) {
                      localStorage.setItem(
                        REFERRAL_PROGRAM_KEY,
                        referral.programId,
                      );
                      break;
                    }
                  }
                  if (e) {
                    await fetchFaceSheetDetails(diagnosisCodesList);
                  }
                }}
                onHoverBorderColor={
                  selectedDphId === secondaryProgramReferralId
                    ? '#F96300'
                    : '#00C6B8'
                }
                onFocusedBorderColor={
                  selectedDphId === secondaryProgramReferralId
                    ? '#F96300'
                    : '#00C6B8'
                }
                disableClearable
              />
            </Box>
          </Box>
        </Box>

        {faceSheetDetails && (
          <Grid
            container
            columnSpacing={'12px'}
            rowSpacing={'12px'}
            sx={{ marginBottom: '24px' }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {faceSheetDetails.demographics &&
                faceSheetDetails.demographics.appSource === 'TBR' && (
                  <Box
                    style={{
                      ...cardStyle,
                      padding: '0px',
                      paddingLeft: '12px',
                      paddingRight: '12px',
                      position: 'relative',
                    }}
                  >
                    {faceSheetDetails && (
                      <ClientJourneyWrapper
                        data={faceSheetDetails.clientJourney}
                        ifspDueDate={faceSheetDetails.demographics.ifspDueDate}
                      />
                    )}
                    <Box
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(42, 66, 65, 0.6)', // Semi-transparent dark overlay
                        zIndex: 1, // Ensures it appears above the component
                        borderRadius: '6px',
                      }}
                    />
                    <Box
                      style={{
                        position: 'absolute',
                        top: '50%', // Center vertically
                        left: '50%', // Center horizontally
                        transform: 'translate(-50%, -50%)', // Proper centering
                        display: 'flex',
                        gap: '16px', // Space between badges
                        zIndex: 2, // Ensure badges appear above overlay
                        flexWrap: 'wrap', // Allow wrapping if there's not enough space
                        justifyContent: 'center', // Center badges horizontally
                        alignItems: 'center', // Center badges vertically
                      }}
                    >
                      <Box
                        style={{
                          display: 'none',
                          backgroundColor: '#89f0ea', // Badge background color
                          color: '#000', // Badge text color
                          padding: '16px 32px',
                          borderRadius: '75px',
                          textAlign: 'center',
                        }}
                      >
                        <MediumTypography
                          labelid={'Facesheet.SSC'}
                          defaultlabel={'Secondary Services Client'}
                          fontweight={600}
                          lineHeight="14px"
                        />
                      </Box>
                      <Box
                        style={{
                          backgroundColor: '#89f0ea', // Different badge background color
                          color: '#000', // Different badge text color
                          padding: '16px 32px',
                          borderRadius: '75px',
                          textAlign: 'center',
                        }}
                      >
                        <MediumTypography
                          labelid={'Facesheet.SSC'}
                          defaultlabel={'Client Created in TBR'}
                          fontweight={600}
                          lineHeight="14px"
                        />
                      </Box>
                    </Box>
                  </Box>
                )}

              {faceSheetDetails.demographics &&
                faceSheetDetails.demographics.appSource !== 'TBR' && (
                  <Box
                    style={{
                      ...cardStyle,
                      padding: '0px',
                      paddingLeft: '12px',
                      paddingRight: '12px',
                      position: 'relative',
                    }}
                  >
                    {faceSheetDetails && (
                      <ClientJourneyWrapper
                        data={faceSheetDetails.clientJourney}
                        ifspDueDate={faceSheetDetails.demographics.ifspDueDate}
                      />
                    )}
                  </Box>
                )}
            </Grid>

            <Grid item xs={12} sm={12} md={8} lg={8}>
              <Box style={cardStyle}>
                {faceSheetDetails &&
                  serviceCoordinatorsList &&
                  intakeCoordinatorsList && (
                    <ClientInfoFaceSheet
                      data={faceSheetDetails}
                      handleServiceDailog={handleServiceDailog}
                      handleIntakeDailog={handleIntakeDailog}
                      handleFormDailog={handleFormDailog}
                      handleSSPProviders={() => ({})}
                      serviceCoordinatorsList={serviceCoordinatorsList}
                      intakeCoordinatorsList={intakeCoordinatorsList}
                    />
                  )}
              </Box>
              <Box
                sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}
              >
                <Box
                  style={{
                    ...cardStyle,
                    width: '50%',
                    marginTop: '12px',
                    marginRight: '12px',
                    height: '100%',
                    minHeight: '200px',
                    maxHeight: 'max-content',
                  }}
                >
                  {faceSheetDetails && (
                    <CommunicationFaceSheet
                      data={faceSheetDetails.communicationLogs}
                    />
                  )}
                </Box>
                <Box
                  style={{
                    ...cardStyle,
                    width: '50%',
                    marginTop: '12px',
                    height: '100%',
                    minHeight: '200px',
                    maxHeight: 'max-content',
                  }}
                >
                  {faceSheetDetails && (
                    <ClientFilesFaceSheet data={faceSheetDetails.clientFiles} />
                  )}
                </Box>
              </Box>
              <Box
                style={{
                  ...cardStyle,
                  marginTop: '12px',
                  height: '100%',
                  minHeight: '225px',
                  maxHeight: 'max-content',
                }}
              >
                {faceSheetDetails && (
                  <TransitionFaceSheet data={faceSheetDetails.transition} />
                )}
              </Box>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4}>
              <Box
                style={{
                  ...cardStyle,
                  backgroundColor: '#00C6B8',
                }}
              >
                {faceSheetDetails && (
                  <UpcomingEventsFaceSheet
                    data={faceSheetDetails.appointments}
                  />
                )}
              </Box>
              <Box style={{ ...cardStyle, marginTop: '12px' }}>
                {faceSheetDetails && (
                  <InsuranceFaceSheet data={faceSheetDetails.insurances} />
                )}
              </Box>
              <Box style={{ ...cardStyle, marginTop: '12px' }}>
                {faceSheetDetails && (
                  <ProgressNotesFaceSheet
                    data={faceSheetDetails.progressNotes}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        )}

        {cancelModal && (
          <ModalPopup
            open={cancelModal}
            onCancel={() => {
              setCancelModal(false);
            }}
            description="formUnsavedChangesMessage"
            onOk={() => {
              handleCloseModal();
              setCancelModal(false);
            }}
            labelId1="Clientpage.cancelbtn"
            negativeActionLabel="cancelText"
            labelId2="Clientpage.Okbtn"
            positiveActionLabel="deleteText"
          />
        )}

        {faceSheetDetails && (
          <Dialog open={referralFormDialogFlag} fullWidth maxWidth="md">
            <DialogTitle>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', // Align items vertically in the center
                }}
                className="mt-sm"
              >
                <Box sx={{ display: 'flex' }}>
                  <Box>
                    <MediumTypography
                      label={'Add Re-Referral'}
                      sxProps={{
                        fontSize: '20px',
                        fontWeight: 'bold',
                        width: '100%',
                        marginRight: '4px',
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', // Align items vertically in the center
                  marginTop: '16px',
                }}
              >
                <Tooltip
                  title={formatName(
                    faceSheetDetails.demographics.firstName,
                    faceSheetDetails.demographics.middleName,
                    faceSheetDetails.demographics.lastName,
                    faceSheetDetails.demographics.suffix,
                  )}
                  arrow
                >
                  <Box sx={{ display: 'flex' }}>
                    <Box>
                      <MediumTypography
                        label={formatName(
                          faceSheetDetails.demographics.firstName,
                          faceSheetDetails.demographics.middleName,
                          faceSheetDetails.demographics.lastName,
                          faceSheetDetails.demographics.suffix,
                        )}
                        sxProps={{
                          fontSize: '20px',
                          maxWidth: '500px',
                          width: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      />
                    </Box>
                  </Box>
                </Tooltip>
              </Box>

              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                  }}
                  className="mt-xs"
                >
                  <SmallTypography
                    text={
                      faceSheetDetails.demographics.sex
                        ? convertGenderToFrontend(
                            faceSheetDetails.demographics.sex,
                          )
                        : '-'
                    }
                    sxProps={{
                      color: '#97A6A5',
                      margin: 0,
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  />
                  <SmallTypography
                    text="|"
                    sxProps={{
                      color: '#97A6A5',
                      margin: 0,
                      paddingX: 1,
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  />
                  <SmallTypography
                    text={faceSheetDetails.demographics.dateOfBirth}
                    sxProps={{
                      color: '#97A6A5',
                      margin: 0,
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  />
                  <SmallTypography
                    text="|"
                    sxProps={{
                      color: '#97A6A5',
                      margin: 0,
                      paddingX: 1,
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  />
                  <SmallTypography
                    text={calculateMonths(
                      faceSheetDetails.demographics.dateOfBirth,
                    ).replace(/[()]/g, '')}
                    sxProps={{
                      color: '#97A6A5',
                      margin: 0,
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  />
                </Box>
              </Grid>
            </DialogTitle>

            <Formik
              innerRef={formRef}
              initialValues={referralInitialValues}
              enableReinitialize={true}
              validateOnBlur={true}
              validateOnChange={false}
              validationSchema={referralCreationSchema}
              validate={validateReferralCreationForm}
              onSubmit={(values) => {
                handleRereferralFormSubmit(values);
              }}
            >
              {({
                values,
                setFieldValue,
                errors,
                touched,
                handleChange,
                handleSubmit,
                handleBlur,
              }) => (
                <>
                  <DialogContent onBlur={handleBlur}>
                    <Box component="div" onBlur={handleBlur}>
                      <Grid container className="mt-xs">
                        <Grid item xs={4.5} lg={4.5} md={4.5}>
                          <DatePickerComponent
                            value={dayjs(values.referralBeginDate)}
                            labelid="AddNewReferralDetails.referralBeginDate"
                            maxDate={dayjs()}
                            defaultlabelid="Referral Begin Date"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                formRef.current?.setValues({
                                  ...values,
                                  referralBeginDate: null,
                                });
                              } else {
                                formRef.current?.setValues({
                                  ...values,
                                  referralBeginDate: formattedDate,
                                });
                              }
                            }}
                            required={true}
                          />

                          {errors.referralBeginDate &&
                            touched.referralBeginDate && (
                              <MediumTypography
                                labelid={errors.referralBeginDate}
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                      </Grid>

                      <MediumTypography
                        labelid="AddNewReferralDetails.referalContactText"
                        defaultlabel="Referral Contact"
                        sxProps={{
                          color: '#2A4241',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          marginY: '16px',
                        }}
                      />
                      <Grid
                        container
                        rowSpacing={'24px'}
                        columnSpacing={'40px'}
                      >
                        <Grid item xs={4.5} lg={4.5}>
                          <Textinput
                            name="referralContactName"
                            labelid="AddNewReferralDetails.Name"
                            defaultlabelid="Name"
                            Value={values.referralContact.referralContactName}
                            inputProps={{
                              maxLength: 50,
                            }}
                            handlechange={(value: string) => {
                              const validatedValue = nameValidation(value);
                              if (validatedValue !== undefined) {
                                setFieldValue(
                                  'referralContact.referralContactName',
                                  validatedValue,
                                );
                              }
                            }}
                          />
                          {errors?.referralContact?.referralContactName &&
                            touched?.referralContact?.referralContactName && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact?.referralContactName
                                }
                                defaultlabel="Name is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>

                        <Grid item xs={4.5} lg={4.5}>
                          <Textinput
                            name="referralContactJobTitle"
                            Value={
                              values.referralContact.referralContactJobTitle
                            }
                            labelid="AddNewReferralDetails.JobTitle"
                            defaultlabelid="Job Title"
                            inputProps={{
                              maxLength: 50,
                            }}
                            handlechange={(value: string) => {
                              const validatedValue = nameValidation(value);
                              if (validatedValue !== undefined) {
                                setFieldValue(
                                  'referralContact.referralContactJobTitle',
                                  validatedValue,
                                );
                              }
                            }}
                          />
                          {errors?.referralContact?.referralContactJobTitle &&
                            touched?.referralContact
                              ?.referralContactJobTitle && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact
                                    ?.referralContactJobTitle
                                }
                                defaultlabel="Job Title is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                        <Grid item xs={4.5} lg={4.5} className="pt-none">
                          <Box component="div" className="flex__">
                            <CheckBoxComponent
                              ischecked={dcfChecked}
                              CheckHandleChange={(value) => {
                                setDcfChecked(value.target.checked);
                                setFieldValue(
                                  'referralContact.isDcf',
                                  value.target.checked,
                                );
                              }}
                              labelid="AddNewReferralDetails.DCF"
                              defaultlabelid="DCF"
                              className="mainText-lg"
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={4.5} lg={4.5}></Grid>

                        <Grid item xs={4.5} lg={4.5}>
                          <DatePickerComponent
                            value={
                              values.referralContact.referralContactDate !==
                              null
                                ? dayjs(
                                    values.referralContact.referralContactDate,
                                  )
                                : null
                            }
                            labelid="AddNewReferralDetails.referralDate"
                            disableFuture={true}
                            minDate={dayjs(
                              faceSheetDetails?.demographics.dateOfBirth,
                            )}
                            defaultlabelid="Referral Contact Date"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                formRef.current?.setValues({
                                  ...values,
                                  referralContact: {
                                    ...values.referralContact,
                                    referralContactDate: null,
                                  },
                                  ifspDueDate: null,
                                });
                              } else {
                                formRef.current?.setValues({
                                  ...values,
                                  referralContact: {
                                    ...values.referralContact,
                                    referralContactDate: formattedDate,
                                  },
                                  ifspDueDate: dateExtension(formattedDate),
                                });
                              }
                            }}
                            required={true}
                          />
                          {values.ifspDueDate && (
                            <MediumTypography
                              label={`${rctl.formatMessage({
                                id: 'AddNewReferralDetails.ifspDueDate',
                              })}: ${values.ifspDueDate as string}`}
                              fontweight={600}
                              sxProps={{
                                color: '#2A4241',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                mt: '4px',
                              }}
                            />
                          )}
                          {errors.referralContact?.referralContactDate &&
                            touched.referralContact?.referralContactDate && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact?.referralContactDate
                                }
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                        <Grid item xs={4.5} lg={4.5}>
                          <DropdownComponent
                            Required
                            names={referralSources}
                            labelid="AddNewReferralDetails.referralSource"
                            defaultlabelid="Referral Source"
                            value={values.referralContact.referralSource}
                            disabled={!hasEditPermission}
                            handleChange={handleChange(
                              'referralContact.referralSource',
                            )}
                          />
                          {errors.referralContact?.referralSource &&
                            touched.referralContact?.referralSource && (
                              <MediumTypography
                                labelid={errors.referralContact?.referralSource}
                                defaultlabel="Referral Source is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>

                        <Grid item xs={4.5} lg={4.5}>
                          <DropdownComponent
                            Required
                            names={referralReasons}
                            labelid="AddNewReferralDetails.referralReason"
                            defaultlabelid="Referral Reason"
                            value={values.referralContact.referralReason}
                            disabled={!hasEditPermission}
                            handleChange={handleChange(
                              'referralContact.referralReason',
                            )}
                          />

                          {errors.referralContact?.referralReason &&
                            touched.referralContact?.referralReason && (
                              <MediumTypography
                                labelid={errors.referralContact?.referralReason}
                                defaultlabel="Referral Reason is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                        <Grid item xs={4.5} lg={4.5}>
                          <Textinput
                            name="referralContactEmail"
                            Value={values.referralContact.referralContactEmail}
                            labelid="AddNewReferralDetails.Email"
                            defaultlabelid="Email"
                            Required={false}
                            inputProps={{
                              maxLength: 50,
                            }}
                            handlechange={(value: string) => {
                              setFieldValue(
                                `referralContact.referralContactEmail`,
                                value,
                              );
                            }}
                          />
                          {errors.referralContact?.referralContactEmail &&
                            touched.referralContact?.referralContactEmail && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact?.referralContactEmail
                                }
                                defaultlabel="Invalid Email Address"
                                className="errorText-md"
                              />
                            )}
                        </Grid>

                        <Grid item xs={4.5} lg={4.5}>
                          <Textinput
                            name="referralContactPhone"
                            Value={values.referralContact.referralContactPhone}
                            labelid="AddNewReferralDetails.referralPhone"
                            defaultlabelid="Phone"
                            inputProps={{
                              maxLength: 50,
                            }}
                            handlechange={(value: string) => {
                              setFieldValue(
                                'referralContact.referralContactPhone',
                                formatPhoneNumber(value),
                              );
                            }}
                          />
                          {errors?.referralContact?.referralContactPhone &&
                            touched?.referralContact?.referralContactPhone && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact?.referralContactPhone
                                }
                                defaultlabel="Phone is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                        <Grid item xs={4.5} lg={4.5}>
                          <Textinput
                            name="referralContactFax"
                            Value={values.referralContact.referralContactFax}
                            labelid="AddNewReferralDetails.Fax"
                            defaultlabelid="Fax"
                            Required={false}
                            inputProps={{
                              maxLength: 50,
                            }}
                            handlechange={(value: string) => {
                              setFieldValue(
                                'referralContact.referralContactFax',
                                formatPhoneNumber(value),
                              );
                            }}
                          />
                          {errors?.referralContact?.referralContactFax &&
                            touched?.referralContact?.referralContactFax && (
                              <MediumTypography
                                labelid={
                                  errors.referralContact?.referralContactFax
                                }
                                defaultlabel="Invalid Fax Number"
                                className="errorText-md"
                              />
                            )}
                        </Grid>

                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            name="notes"
                            placeholder={rctl.formatMessage({
                              id: 'AddNewReferralDetails.notes',
                              defaultMessage: 'Notes',
                            })}
                            rows={4}
                            Value={values.referralContact.notes}
                            maxLength={2000}
                            handlechange={(value: string) => {
                              setFieldValue('referralContact.notes', value);
                            }}
                          />

                          {errors?.referralContact?.notes &&
                            touched?.referralContact?.notes && (
                              <MediumTypography
                                labelid={errors.referralContact.notes}
                                defaultlabel="Notes is Required"
                                className="errorText-md"
                              />
                            )}
                        </Grid>
                      </Grid>
                    </Box>
                  </DialogContent>

                  <DialogActions>
                    <Box
                      sx={{ margin: '12px' }}
                      display={'flex'}
                      justifyContent={'flex-end'}
                    >
                      <ButtonComponent
                        className="btn-primary btn-cancel alrt_Width_btn mr-md"
                        variantType="contained"
                        labelId={'cancelText'}
                        defaultLabelId={'Cancel'}
                        onClick={() => {
                          if (!_.isEqual(referralInitialValues, values)) {
                            setOpenModal(true);
                          } else {
                            setReferralFormDialogFlag(false);
                          }
                        }}
                      />

                      <ButtonComponent
                        variantType="contained"
                        type="submit"
                        className="btn-primary btn-submit alrt_Width_btn"
                        labelId={'saveText'}
                        defaultLabelId={'Save'}
                        onClick={handleSubmit}
                        disabled={_.isEqual(referralInitialValues, values)}
                      />
                    </Box>
                  </DialogActions>
                </>
              )}
            </Formik>
            <ModalPopup
              description="formUnsavedChangesMessage"
              open={openModal}
              onCancel={() => {
                setOpenModal(false);
              }}
              onOk={() => {
                formRef.current?.resetForm();
                setDcfChecked(false);
                setReferralFormDialogFlag(false);
                setOpenModal(false);
              }}
              labelId1="Clientpage.Nobtn"
              negativeActionLabel="No"
              labelId2="Clientpage.Yesbtn"
              positiveActionLabel="Yes"
            />
          </Dialog>
        )}
      </Box>
    </Box>
  );
};

export default FaceSheetScreen;
